import { useCallback } from 'react';
import { Flex, Typography, PrimaryButton, RemoteImage } from '@banhala/ui-kit';
import type { EmptyProps } from './types';
import { bridge, isNil } from '../../../../utils';

export const Empty = ({ body }: EmptyProps) => {
  const item = body?.item ?? null;

  const handlePressButton = useCallback(() => {
    if (item?.button?.deeplink) {
      bridge.openDeeplink(item.button.deeplink);
    }
  }, [item?.button?.deeplink]);

  if (isNil(item)) {
    return null;
  }

  const { image, title, description, button } = item;

  return (
    <Flex.Column width="100%" alignItems="center" gap={24}>
      <Flex.Column alignItems="center" gap={8} width={240}>
        {image && (
          <RemoteImage uri={image} width={64} height={64} />
        )}
        <Typography type="subtitle1" color="content_secondary" textAlign="center">
          {title}
        </Typography>
        {description && (
          <Typography type="body2" color="content_tertiary" textAlign="center">
            {description}
          </Typography>
        )}
      </Flex.Column>

      {button && (
        <Flex.Row justifyContent="center">
          <PrimaryButton
            size="large"
            color="pink"
            onPress={handlePressButton}
          >
            {button.title}
          </PrimaryButton>
        </Flex.Row>
      )}
    </Flex.Column>
  );
};
